export default "__VITE_ASSET__CvqvEM0J__"